import MuiDialog from '@mui/material/Dialog'
import MuiDialogActions from '@mui/material/DialogActions'
import MuiDialogContent from '@mui/material/DialogContent'
import MuiDialogContentText from '@mui/material/DialogContentText'
import MuiDialogTitle from '@mui/material/DialogTitle'
import MuiLoadingButton from '@mui/lab/LoadingButton'

const confirmDialog = ({ promiseArguments, handleNo, handleYes, loading }) => {
  if (!promiseArguments) {
    return null
  }

  return (
    <MuiDialog maxWidth="xs" open={!!promiseArguments}>
      <MuiDialogTitle>Are you sure?</MuiDialogTitle>
      <MuiDialogContent dividers>
        {promiseArguments.newRow.enabled && (
          <MuiDialogContentText>
            If you enable this user, they will be able to log in to the system.
          </MuiDialogContentText>
        )}
        {!promiseArguments.newRow.enabled && (
          <MuiDialogContentText>
            If you disable this user, they will no longer be able to access the application.
          </MuiDialogContentText>
        )}
      </MuiDialogContent>
      <MuiDialogActions>
        <MuiLoadingButton onClick={handleNo}>No</MuiLoadingButton>
        <MuiLoadingButton loading={loading} color="error" onClick={handleYes}>
          Yes
        </MuiLoadingButton>
      </MuiDialogActions>
    </MuiDialog>
  )
}

export default confirmDialog
